import './App.css';
import Hero from './Hero';
import About from './About';
import ContactForm from './ContactForm';

function App() {
  return (
    <div className="App">
      <nav className="navbar">
        <div className="nav-container">
          <h1 className="logo">Conrad Tutoring</h1>
          <ul className="nav-links">
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>
      </nav>

      <Hero />
      <About />
      <ContactForm />

      <footer className="footer">
        <p>&copy; 2025 Conrad Tutoring. Meeting the new needs of students with personalized, results-driven tutoring in a changing academic landscape.</p>
      </footer>
    </div>
  );
}

export default App;
